module.exports = __webpack_public_path__ + "img/img_stgl1.f6da17f5.png";